export default {
  SET_RULES (state, value) {
    state.rules = value
  },
}
